import { EmeraldError } from 'src/common/api/emerald-error';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { addTransactionLine } from 'src/items-list/business-logic/add-transaction-line';
import {
  closeTbrQuantityModal,
  ITBRQuantityModalProps,
  showTbrQuantityModal,
} from '../../components/tbr-components/transaction-based-return-quantity-modal';

export const handleTbrQuantitySelect = (givenMax: number, itemId?: string, scanData?: string) =>
  new Promise<void>((resolve, reject) => {
    const onApprove = (quantity: string) => {
      if (Number(quantity) > givenMax) {
        reject(new EmeraldError('IllegalQty'));
      } else {
        const input: IItemInputData = {
          itemId: scanData ?? itemId,
          quantity: Number(quantity),
          quantityEntryMethod: EntryMethod.Keyed,
          entryMethod: scanData ? EntryMethod.Scanned : EntryMethod.Automatic,
        };

        addTransactionLine(input)
          .then(resolve)
          .catch(reject);
      }
    };

    const props: ITBRQuantityModalProps = {
      onApprove: onApprove,
      onClose: resolve,
      givenMax,
    };

    showTbrQuantityModal(props);
  }).finally(closeTbrQuantityModal);
